module.exports = __webpack_public_path__ + "img/open.069a59eb.svg";